import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { Topic } from "@teammood/timeline";
import { TranslateModule } from "@ngx-translate/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { debounceTime, distinctUntilChanged, Subject, takeUntil, tap } from "rxjs";
import { TmMoodPickersComponent } from "../../../../shared/ui/moodpickers/mood-pickers.component";

@Component({
    selector: "tm-edit-topic-box",
    templateUrl: "./edit-topic-box.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        TmMoodPickersComponent
    ]
})
export class EditTopicBoxComponent implements OnInit, OnDestroy {

    @Input({required: true})
    topic: Topic;

    @Output()
    onEdit: EventEmitter<Topic> = new EventEmitter();

    @Output()
    onCancel: EventEmitter<void> = new EventEmitter();

    protected topicCommentCtrl = new FormControl<string>('');

    protected topicPlaceholder: string;

    private _destroy$ = new Subject<void>();

    ngOnInit() {
        this.topicPlaceholder = this.topic.type === 'question' ? 'question-request-modal.placeholder'
                    : this.topic.type === 'issue' ? 'issue-request-modal.placeholder'
                        : undefined;

        this.topicCommentCtrl.setValue(this.topic.title.body);

        this.topicCommentCtrl.valueChanges.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            tap(() => {
                this.topic.title.body = this.topicCommentCtrl.getRawValue();
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    protected fromMoodPicker (element: string) {
        if (this.topic.title.body) {
            this.topicCommentCtrl.setValue(this.topic.title.body + ' ' + element);
        } else {
            this.topicCommentCtrl.setValue(element);
        }
    }

    protected saveUpdate() {
        if (this.topic.title.body.length > 0){
            this.onEdit.emit(this.topic);
        } else{
            this.cancelUpdate();
        }
    }

    protected cancelUpdate() {
        this.onCancel.emit();
    }
}